import React from 'react';
import {useSelector} from 'react-redux';
import ReCAPTCHA from 'react-google-recaptcha';
import useGetPlatformInfo from 'hooks/useGetPlatformInfo';
import gRecaptchaManager from './GRecaptchaManager';
import {RootState} from '../../store';

const GRecaptcha: React.FC = () => {
    const {
        googleRecaptchaKey,
        disableRecaptcha,
    } = useSelector((state: RootState) => state.auth);
     const { isShellApp } = useGetPlatformInfo();

    const { recaptchaRef } = gRecaptchaManager;

    if (!disableRecaptcha) {
        return (
            <div style={{visibility: isShellApp ? 'hidden' : 'visible'}}>
                <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey={googleRecaptchaKey} />
            </div>
        );
    }
    return (<div />);
};

export default GRecaptcha;
